// Canonical/OG/JSON-LD URLs need the real production domain even when this
// page is rendered against a local `vite preview` port (e.g. during
// `npm run prerender`). Set VITE_SITE_URL at build time for a prerender
// pass targeting the live domain; otherwise falls back to whatever origin
// the browser is actually on, which is correct for normal client use.
export function getSiteOrigin(): string {
  const configured = import.meta.env.VITE_SITE_URL as string | undefined;
  if (configured) return configured.replace(/\/+$/, '');
  return typeof window !== 'undefined' ? window.location.origin : '';
}
